module.exports = __webpack_public_path__ + "media/images/cluster-4-digit-fdb1119f1b0de95745606fb7ed4b605d.png";